module.exports = __webpack_public_path__ + "img/services-09.31055711.jpg";